import React, {useEffect} from "react";
import PropTypes from 'prop-types';
import TagManagerService from 'services/TagManager';
import Link from 'components/Link';
import {translateIcons} from 'config/constants';
import style from './style.scss'; //NOSONAR

const BannerPromotionsOffers = (props) => {
    
    const promotions = props.item.promotions[0];
    const suffix = promotions.suffix.split('DSCTO.');
    let countItem = 1;
    promotions.typePromotion = 'Vitrina' + props.shelfIsland;
    let position = 'slot' + (countItem);
    let tagItem = [{
        id: promotions.category,
        name: promotions.title,
        creative: promotions.typePromotion,
        position: position
    }];

    useEffect(()=>{
        TagManagerService.promotionsImpressions(tagItem);
    },[])

    const promotionClick = () =>  {
        const categoryClick = {
            id: promotions.category,
            title: promotions.title,
            creative: 'Vitrina ' + props.shelfIsland,
            position: position
            
        };

        TagManagerService.promotionsClick(categoryClick);
    };

    const fullWidth = props.item.fullWidth;

    const categoryParent = () => {
        const value = promotions.category ? ('cat-' + promotions.category.split("/")[0]) : '';
        return translateIcons[value] || value;
    };

    return (
        <section className={"wrapper-banner-promotions-offers" + (fullWidth ? ' banner-fullwidth' : '')}>
            <div className="banner-promotions-offers-image">
                <div className="banner-promotions-offers-icon">
                    <i className={'font-icn-cat ' + categoryParent()}></i>
                </div>
            </div>
            
            <div className="wrapper-banner-promotions-offers-content">
                <div className="banner-promotions-offers-text">
                    <div className="banner-promotions-offers-text-wrap-dscto">
                        <strong className="banner-promotions-offers-dscto">
                            {promotions.label_promotion}
                        </strong>
                        <sub className="banner-promotions-offers-suffix">{suffix}</sub>
                    </div>
                    <span className="banner-promotions-offers-title">en {promotions.title}</span>
                </div>
                <Link to={promotions.url} target={promotions.url_target} className="banner-promotions-offers-button" rel="noopener noreferrer" onClick={() => promotionClick()}>Ver Ofertas</Link>
            </div>
        </section>
    )
}
BannerPromotionsOffers.propTypes = {
    item: PropTypes.object,
    shelfIsland: PropTypes.number
}
export default BannerPromotionsOffers;
